import { CHAT } from "../lib/constants/actions";

export const getChatRooms = (data) => {
    return { type: CHAT.GET_ROOMS, payload: data }
}

export const getChatRoomsSuccess = (data) => {
    return { type: CHAT.GET_ROOMS_SUCCESS, payload: data }
}


export const getChatMessages = (data) => {
    return { type: CHAT.GET_MESSAGES, payload: data }
}

export const getChatMessagesSuccess = (data) => {
    return { type: CHAT.GET_MESSAGES_SUCCESS, payload: data }
}


export const makeAccessRequest = (data) => {
    return { type: CHAT.ACCESS_REQUEST, payload: data }
}

export const makeAccessRequestSuccess = (data) => {
    return { type: CHAT.ACCESS_REQUEST_SUCCESS, payload: data }
}









